<div class="contenedor-modal">
    <p class="title mb-3 text-center"><b>Gracias por contarnos por qué cancelas la solicitud de crédito</b></p>
    <div class="row">
      <div class="contenedor-option">
        <mat-form-field appearance="outline" appearance="fill">
            <mat-label>Causal de rechazo</mat-label>
            <mat-select [(ngModel)]="cancelSeleccionado">
              <mat-option [value]="item.description" *ngFor="let item of opcionesCancelacion |async">
                {{item.description}}
              </mat-option>
            </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="contenedor-botones">
        <button (click)="mostrarModalFuncionalidad()" class="btn btn-azul btn-redondo">Cancelar solicitud y volver al comercio</button>
        <a class="cancel-credit" (click)="cerrarModal()">Volver</a>
      </div>
</div>